// ======================================================================
// File: src/modules/ipe/dashboard/crm/components/RecentEnquiriesWidget.jsx
// Purpose:
// CRM Executive Recent Enquiries Widget
// ======================================================================

import React from "react";

export default function RecentEnquiriesWidget({
  enquiries = [],
  onViewAll,
  onRowClick,
}) {
  const getStatusStyle = (status) => {
    switch (status) {
      case "Open":
        return {
          bg: "#dbeafe",
          color: "#1d4ed8",
        };

      case "Follow-up":
        return {
          bg: "#fef3c7",
          color: "#b45309",
        };

      case "Closed":
        return {
          bg: "#dcfce7",
          color: "#15803d",
        };

      default:
        return {
          bg: "#e5e7eb",
          color: "#374151",
        };
    }
  };

  const openCount = enquiries.filter(
    (x) => x.status === "Open"
  ).length;

  const followupCount = enquiries.filter(
    (x) => x.status === "Follow-up"
  ).length;

  return (
    <div
      style={{
        background: "#fff",
        borderRadius: "12px",
        padding: "18px",
        boxShadow:
          "0 2px 10px rgba(0,0,0,.06)",
        border: "1px solid #e5e7eb",
      }}
    >
      {/* =====================================================
          HEADER
      ===================================================== */}

      <div
        style={{
          display: "flex",
          justifyContent:
            "space-between",
          alignItems: "center",
          marginBottom: "18px",
        }}
      >
        <h3
          style={{
            margin: 0,
            fontSize: "18px",
            fontWeight: 700,
          }}
        >
          Recent Enquiries
        </h3>

        <button
          onClick={onViewAll}
          style={{
            border:
              "1px solid #d1d5db",
            background: "#fff",
            padding: "6px 12px",
            borderRadius: "6px",
            cursor: "pointer",
            fontSize: "12px",
            fontWeight: 600,
          }}
        >
          View All
        </button>
      </div>

      {/* =====================================================
          SUMMARY
      ===================================================== */}

      <div
        style={{
          display: "grid",
          gridTemplateColumns:
            "1fr 1fr 1fr",
          gap: "12px",
          marginBottom: "18px",
        }}
      >
        <div
          style={{
            background: "#eff6ff",
            padding: "12px",
            borderRadius: "10px",
          }}
        >
          <div
            style={{
              fontSize: "11px",
              color: "#64748b",
            }}
          >
            Total
          </div>

          <div
            style={{
              fontSize: "22px",
              fontWeight: 700,
              color: "#2563eb",
            }}
          >
            {enquiries.length}
          </div>
        </div>

        <div
          style={{
            background: "#fef3c7",
            padding: "12px",
            borderRadius: "10px",
          }}
        >
          <div
            style={{
              fontSize: "11px",
              color: "#64748b",
            }}
          >
            Follow Up
          </div>

          <div
            style={{
              fontSize: "22px",
              fontWeight: 700,
              color: "#b45309",
            }}
          >
            {followupCount}
          </div>
        </div>

        <div
          style={{
            background: "#dcfce7",
            padding: "12px",
            borderRadius: "10px",
          }}
        >
          <div
            style={{
              fontSize: "11px",
              color: "#64748b",
            }}
          >
            Open
          </div>

          <div
            style={{
              fontSize: "22px",
              fontWeight: 700,
              color: "#15803d",
            }}
          >
            {openCount}
          </div>
        </div>
      </div>

      {/* =====================================================
          ENQUIRY CARDS
      ===================================================== */}

      <div>
        {enquiries.map((row, index) => {
          const status =
            getStatusStyle(
              row.status
            );

          return (
            <div
              key={row.enquiry_no}
              onClick={() =>
                onRowClick?.(row)
              }
              style={{
                border:
                  "1px solid #e5e7eb",
                borderRadius: "10px",
                padding: "14px",
                marginBottom: "10px",
                cursor: "pointer",
                transition:
                  "all .25s ease",
                background: "#fff",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform =
                  "translateY(-2px)";
                e.currentTarget.style.boxShadow =
                  "0 8px 18px rgba(0,0,0,.08)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform =
                  "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "none";
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                }}
              >
                {/* AVATAR */}

                <div
                  style={{
                    width: "42px",
                    height: "42px",
                    borderRadius: "50%",
                    background:
                      "#2563eb",
                    color: "#fff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent:
                      "center",
                    fontWeight: 700,
                  }}
                >
                  {row.customer
                    ?.substring(0, 1)
                    ?.toUpperCase()}
                </div>

                {/* INFO */}

                <div
                  style={{
                    flex: 1,
                  }}
                >
                  <div
                    style={{
                      fontWeight: 700,
                      color: "#111827",
                    }}
                  >
                    {row.customer}
                  </div>

                  <div
                    style={{
                      fontSize: "12px",
                      color: "#64748b",
                    }}
                  >
                    {row.enquiry_no}
                  </div>
                </div>

                {/* STATUS */}

                <span
                  style={{
                    background:
                      status.bg,
                    color:
                      status.color,
                    padding:
                      "4px 10px",
                    borderRadius:
                      "999px",
                    fontSize: "12px",
                    fontWeight: 700,
                  }}
                >
                  {row.status}
                </span>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent:
                    "space-between",
                  marginTop: "12px",
                  fontSize: "12px",
                  color: "#64748b",
                }}
              >
                <span>
                  Date: {row.date}
                </span>

                <span>
                  Ageing:
                  {" "}
                  {index + 1}
                  {" "}
                  Days
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}